export default __webpack_public_path__ + "./images/it.78522296.png";